// Actions
export const CONSTRUCTION_FETCH  = '[Construction] Fetch'

// Mutations
export const CONSTRUCTION_META   = '[Construction] meta'
export const CONSTRUCTION_OBTAIN = '[Construction] obtain'
export const CONSTRUCTION_CLEAR  = '[Construction] clear'
export const CONSTRUCTION_SET_LOADING = '[Construction] set loading'
